"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'user.profile.title': 'Modifica Profilo',
    'user.profile.back': 'Torna al Pannello',
    'user.profile.name.label': 'Nome Completo',
    'user.profile.name.placeholder': 'Mario Rossi',
    'user.profile.username.label': 'Nome Utente',
    'user.profile.username.placeholder': 'mariorossi',
    'user.profile.email.label': 'Email',
    'user.profile.email.placeholder': 'email@indirizzo.it',
    'user.profile.picture.label': 'Foto Profilo',
    'user.profile.picture.placeholder': 'Scegli foto profilo...',
    'user.profile.picture.remove': '×',
    'user.profile.changePassword.title': 'Cambia Password',
    'user.profile.changePassword.description': 'Lascia vuoti i campi password se non vuoi cambiare la tua password.',
    'user.profile.password.new.label': 'Nuova Password',
    'user.profile.password.placeholder': 'Inserisci nuova password',
    'user.profile.password.repeat.label': 'Ripeti Nuova Password',
    'user.profile.password.repeat.placeholder': 'Ripeti nuova password',
    'user.profile.submit': 'Aggiorna Profilo',
    'user.profile.form.passwordMismatch': 'Le password non corrispondono',
    'user.profile.form.updateFailed': 'Errore nell\'aggiornamento del profilo',
    'user.profile.form.updateSuccess': 'Profilo aggiornato con successo',
};
